import React from "react";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import qualityIcon from "../images/Quality.png";
import deploymentIcon from "../images/Deployment & Launch.png";
import supportIcon from "../images/Support.png";
import developmentIcon from "../images/development.png";
import testingIcon from "../images/Testing.png";

// Process data array
const processData = [
  {
    id: 1,
    step: "01",
    title: "Research & Discovery",
    icon: researchIcon,
    description:
      "We begin by understanding your business goals, user needs, and market trends. This phase ensures we build the right solution from the start.",
  },
  {
    id: 2,
    step: "02",
    title: "Planning & Strategy",
    icon: planningIcon,
    description:
      "Our team outlines the project roadmap, defines technology stacks, and creates a clear execution plan tailored to your business objectives.",
  },
  {
    id: 3,
    step: "03",
    title: "Design & Prototyping",
    icon: designIcon,
    description:
      "We create intuitive UI/UX designs and interactive prototypes that focus on usability, aesthetics, and user engagement.",
  },
  {
    id: 4,
    step: "04",
    title: "Development",
    icon: developmentIcon,
    description:
      "Our developers build scalable, secure, and high-performing solutions using the latest technologies and coding standards.",
  },
  {
    id: 5,
    step: "05",
    title: "Quality Assurance",
    icon: qualityIcon,
    description:
      "Our developers build scalable, secure, and high-performing solutions using the latest technologies and coding standards.",
  },
  {
    id: 6,
    step: "06",
    title: "Testing & QA",
    icon: testingIcon,
    description:
      "Rigorous testing is conducted to ensure functionality, performance, and security—fixing bugs before deployment.",
  },
  {
    id: 7,
    step: "07",
    title: "Deployment & Launch",
    icon: deploymentIcon,
    description:
      "We deploy the final product on your preferred platform with full support, ensuring a smooth and successful launch.",
  },
  {
    id: 8,
    step: "08",
    title: "Maintenance & Support",
    icon: supportIcon,
    description:
      "Post-launch, we provide ongoing updates, performance monitoring, and technical support to keep your system running optimally.",
  },
];

const Planning = () => {
  return (
    <section className="planning-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
            <span className="about-label">Planning</span>
            <h2 className="title">Our Process</h2>
            <p className="sub-title text-black ">
              At Hope Web Solutions, we follow a smart, data-driven approach
              powered by AI to deliver tailored solutions. Our process focuses
              on innovation, efficiency, and scalable growth to help your
              business succeed with the latest technology.
            </p>
          </div>
        </div>
        <div className="process-grid">
          {processData.map((process) => (
            <div key={process.id} className="process-card">
              <div className="process-icon">
                <img src={process.icon} alt={process.title} />
              </div>
              <div className="process-step">{process.step}</div>
              <div className="process-title">{process.title}</div>
              <div className="process-underline-flex">
                <div className="process-underline"></div>
                <div className="process-underline"></div>
              </div>
              <div className="process-desc">{process.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Planning;
